// Remove historical shared cookies while keeping new navigation state on this host.
const clearLegacySharedCookie = (cookieName: string) => {
  const hostname = window.location.hostname;
  if (
    hostname === "teachplus.com.br" ||
    hostname.endsWith(".teachplus.com.br")
  ) {
    document.cookie = `${cookieName}=; domain=.teachplus.com.br; path=/; Max-Age=0; SameSite=Lax; ${window.location.protocol === "https:" ? "Secure" : ""}`;
  }
};

const setCookie = (cookieName: string, cookieValue: string | object) => {
  if (typeof document === "undefined") return;
  clearLegacySharedCookie(cookieName);
  document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(cookieValue))}; path=/; SameSite=Lax; ${window.location.protocol === "https:" ? "Secure" : ""}`;
};

const getCookie = (cookieName: string) => {
  if (typeof document === "undefined") return "";
  const name = cookieName + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      try {
        return JSON.parse(
          decodeURIComponent(c.substring(name.length, c.length)),
        );
      } catch {
        return "";
      }
    }
  }
  return "";
};

export { setCookie, getCookie };
